import React, { Component } from "react";
import ReactDOM from 'react-dom';

import Registry from "../../../../Utils/Registry";
import Helpers from "../../../../Utils/Helpers";


class OperationsOrdersTableLine extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.toggleActions = this.toggleActions.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);

        this.state = {
            actions_toggled: false,
            dropDownOpen: false
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDocClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocClick, false);
    }

    handleDocClick(e){
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            if(this.state.actions_toggled)
                this.setState({actions_toggled: false});
        }
    }

    toggleActions(){
        this.setState({
            actions_toggled: !this.state.actions_toggled,
        });
    }

    getQtyCell = () => {
        let volByUnit = {};
        
        this.props.order.gas_needed.map(shorten => {
            if(this.props.order.gas[shorten]) {
                const {unit, quantity_delivered} = this.props.order.gas[shorten];
                if(volByUnit[unit] === undefined)
                    volByUnit[unit] = 0;
                volByUnit[unit] += quantity_delivered;
            }
        });
        
        if(!Object.keys(volByUnit).length)
            return "-";

        return Object.keys(volByUnit)
            .map(unit => <span key={`${this.props.order.id}-${unit}`}>{volByUnit[unit].toFixed(2)} {unit}</span>)
            .reduce((prev, curr) => [prev, ' | ', curr]);
    };

    render(){
        return (
            <tr onClick={() => this.props.onLineClicked(this.props.order)} className={ (this.props.doMultiSelect && this.state.selectedOrder ? ' multi-selected' : "") + (this.props.order.paid === 3 ? " default-payment" : "") }>
                <td className={this.props.order.cancel_request_datetime ? "pad-0 pad-l-15 vertical-align-middle-important" : "pad-xs-10-0"}>
                    {this.props.order.shorten}
                    {
                        this.props.order.cancel_request_datetime ?
                            <div className="orange f-10">En attente d'annulation</div>
                            :
                            ""
                    }
                </td>
                <td className="wp-10 pad-xs-5-5">{
                    Helpers.formatDate(
                        (this.props.order.status === 'waiting' ? this.props.order.date_min : this.props.order.start_datetime)
                        , "DD/MM/YY"
                    )
                }</td>
                <td className="_w-100">{
                    Helpers.formatDate((this.props.order.status === 'waiting' ? this.props.order.date_min : this.props.order.start_datetime), "HH[h]mm")
                    + (
                        this.props.order.status === 'waiting' ? " à " + Helpers.formatDate(this.props.order.date_max, "HH[h]mm") : ""
                    )
                }</td>
                <td className="center pad-xs-30-5">{ this.props.order.vehicles.length }</td>
                <td className="wp-15 pad-xs-30-5">{this.getQtyCell()}</td>
                <td className="center w-30">
                    {this.props.order.paid === 0 || this.props.order.paid === 4 ? <i className="icon icon-close blue_dark tooltip-info-status" aria-hidden="true"><span className="tooltip-info-status-text">Non pay&eacute;</span></i> : "" }
                    {this.props.order.paid === 1 ? <i className="icon icon-check green tooltip-info-status" aria-hidden="true"><span className="tooltip-info-status-text">Pay&eacute;</span></i> : "" }
                    {this.props.order.paid === 2 ? <i className="icon icon-refresh orange tooltip-info-status" aria-hidden="true"><span className="tooltip-info-status-text">Paiement en cours</span></i> : "" }
                    {this.props.order.paid === 3 || this.props.order.paid === 5 ? <i className="icon icon-alert red tooltip-info-status" aria-hidden="true"><span className="tooltip-info-status-text">D&eacute;faut de paiement</span></i> : "" }
                </td>
                <td className="ty-action-td _w-50 relative" onClick={e => {e.stopPropagation();}}>
                    {
                        this.props.actions.length ?
                            <div className="action-carret" onClick={ this.toggleActions }>
                                <i className={"icon icon-chevron-" + (this.state.actions_toggled ? "up" : "down")} aria-hidden="true"> </i>
                            </div>
                            :
                            ""
                    }
                    {
                        this.props.actions.length && this.state.actions_toggled ?
                        <ul className="ty-item-actions-list">
                            {
                                this.props.actions.map((action, i) => {
                                    return <li
                                        key={i}
                                        className="ty-item-action"
                                        onClick={e => { action.onclick(e); this.toggleActions(); }}>
                                        { action.label }
                                    </li>;
                                })
                            }
                        </ul>
                        :
                        ""
                    }
                </td>
            </tr>
        );
    }
}

OperationsOrdersTableLine.defaultProps = {
    order: {},
    onLineClicked: (order) => {},
    actions: [
        {label: "Supprimer", action: () => {}},
        {label: "Modifier", action: () => {}}
    ]
};

export default OperationsOrdersTableLine;



// WEBPACK FOOTER //
// ./src/components/Operations/Orders/Table/Line.js